import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 bg-gray-50" data-id="element-82">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white border-4 border-gold p-6 md:p-10 relative shadow-lg" data-id="element-84">
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-matte rounded-full p-2.5 border-4 border-gold shadow-lg" data-id="element-85">
            <ShieldCheck className="w-10 h-10 text-gold" data-id="element-86" />
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-matte mt-4 mb-6" data-id="element-87">
            GARANTÍA TOTAL 7 DÍAS
          </h2>

          <div className="text-left max-w-sm mx-auto space-y-3 mb-6" data-id="element-88">
            <div className="flex items-center" data-id="element-89">
              <Check className="w-5 h-5 text-green-600 mr-2.5 flex-shrink-0" data-id="element-90" />
              <p className="text-base text-matte" data-id="element-91">
                Te devolvemos el <strong data-id="element-92">100%</strong> sin preguntas
              </p>
            </div>
            <div className="flex items-center" data-id="element-93">
              <Check className="w-5 h-5 text-green-600 mr-2.5 flex-shrink-0" data-id="element-94" />
              <p className="text-base text-matte" data-id="element-95">
                Sin formularios — un WhatsApp alcanza
              </p>
            </div>
            <div className="flex items-center" data-id="element-96">
              <Check className="w-5 h-5 text-green-600 mr-2.5 flex-shrink-0" data-id="element-97" />
              <p className="text-base text-matte" data-id="element-98">
                Tu dinero de vuelta en <strong data-id="element-99">24-48hs</strong>
              </p>
            </div>
          </div>

          <p className="text-lg font-bold text-steel italic" data-id="element-100">
            "Ponemos el dinero en riesgo nosotros, no vos."
          </p>
        </motion.div>
      </div>
    </section>;
}